import * as React from 'react';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';

import Box from '@mui/material/Box';
import Input from '@mui/material/Input';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Link from '@mui/material/Link';

import { useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { bbsNoticeCreate } from "../../../actions/notice";

import { useNavigate, useParams } from 'react-router-dom';

const ariaLabel = { 'aria-label': 'description' };

export default function NoticeWrite() {

    const [title, setTitle] = useState("");
    const [contents, setContents] = useState("");
    const board_name  = useParams().board_name;
    console.log("board_name : ", board_name);

    // 리듀서 값들 저장
    const userInfo = useSelector(state => state.auth);
    console.log("userInfo : ", userInfo);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const onTitleChange = (event) => {
        setTitle(event.target.value);
    }
    
    const onContentsChange = (event) => {
        setContents(event.target.value);
    }

    const onWriteSubmit = (event) => {

        event.preventDefault();
        
        if(userInfo.isLoggedIn)
        {
            const sendWrite = {
                table_name: board_name,
                mem_idx: userInfo.user.idx,
                name: userInfo.user.name,
                title: title,
                contents: contents
            }
    
            if (sendWrite.title === "")
            {
                alert("제목이 없습니다. 작성해주세요.");
                return;
            }
    
            if (sendWrite.contents === "")
            {
                alert("내용이 없습니다. 작성해주세요.");
                return;
            }
    
            console.log("sendWrite : ", sendWrite);
        
            // 여기서 디스패치로~
            dispatch(bbsNoticeCreate(sendWrite))
            .then(data => 
            {
                console.log("data : ", data);
                if (!data.success)
                {
                    alert(data.msg);
                    return;
                }
                else
                    navigate(`/dashboard/NoticeList/${board_name}`);
    
            })
            .catch(e => {
                console.log(e);
            });
        }
        else
        {
            alert("로그인 후에 댓글을 달 수 있습니다.");
            return;
        }
    }

  return (
    <Card sx={{ minWidth: 275 }}>
      <CardContent>
      <Box
        sx={{
            '& > :not(style)': { m: 1, width: '400px' },
        }}
        noValidate
        autoComplete="off"
        >
        공지사항 쓰기
        </Box>
        <Box
        sx={{
            '& > :not(style)': { m: 1, width: '400px' },
        }}
        noValidate
        autoComplete="off"
        >
        <Input 
            placeholder="공지 제목" 
            id="title"
            name="title" 
            inputProps={ariaLabel} 
            onChange={onTitleChange} 
            maxLength="200" 
        />
        </Box>
        <Box
        sx={{
            '& > :not(style)': { m: 1, width: '400px' },
        }}
        noValidate
        autoComplete="off"
        >
        <TextareaAutosize
            aria-label="minimum height"
            minRows={10}
            placeholder="공지 내용"
            style={{ width: 450 }}
            onChange={onContentsChange}
            id="contents" 
            name="contents"
        />
        </Box>
      </CardContent>
      <CardActions>
        <Button onClick={onWriteSubmit} size="small">쓰기</Button>
        <Link href={`/dashboard/NoticeList/${board_name}`} underline="none">목록</Link>
      </CardActions>
    </Card>
  );
}